import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';
import {
  ConfigureEncryptionRequest,
  EncryptionStatus,
} from './encryption-types';

export const configureEncryption = async (
  config: ConfigureEncryptionRequest,
): Promise<EncryptionStatus> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;
  if (!orgId) {
    throw new Error('No organization selected');
  }

  const response = await apiRequest<EncryptionStatus>({
    url: `/organizations/${orgId}/encryption/configure`,
    method: 'POST',
    target: 'platform',
    body: config as unknown as Record<string, unknown>,
  });

  if (response?.detail) {
    throw new Error(response.detail || 'Failed to configure encryption');
  }

  return response.data ?? { configured: false };
};
